import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-setup',
  templateUrl: './user-setup.component.html',
  styleUrls: ['./user-setup.component.css']
})
export class UserSetupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
